import { Route } from '~/routes/types';
import { FILES_MAIN } from '~/routes/private/files/constants';
import Files from '~/pages/files';

export const files: Route = {
  to: FILES_MAIN,
  exact: true,
  component: Files
};
